import { useCallback } from "react";
import { axiosChallenges } from "./axios";

export interface IDeleteFavoriteOffer {
  offerId: string;
}

export const useDeleteFavoriteOffer = () => {
  const [state, execute, cancel] = axiosChallenges<void, IDeleteFavoriteOffer, unknown>(
    {
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: IDeleteFavoriteOffer) => {
      return execute({
        url: "/stars",
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
